import download from "downloadjs";
import { generatePdf } from "./api"

export default function useQuery({id}) {
    const downloadPdf = async (fileName = 'file.pdf') => {
        try {

        const responsePdf = await generatePdf(id);
    
        if (responsePdf)
            download(
                responsePdf,
                'attendance.pdf',
                "application/pdf"
            );
        } catch (error) {
            console.error('PDF download error:', error);
        }
    };

    return {
        downloadPdf,
    };
}
